import { Field, NumericInput, TextOutput } from 'Components/Core';
import { QestlabListDropdown } from 'Components/List';
import ListType from 'Components/List/QestlabListDropdown/ListType';
import { WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { hasValue } from 'Lib/Any';
import { Guid } from 'Lib/Guid';
import React from 'react';
import { useSelector } from 'react-redux';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { FieldSet, ListFieldSection, PageSection } from '../../../../Layout';

const Section: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const gaugeCalibrationImportMismatch = useSelector(
    createWorksheetSelector!('Preparation.NuclearDensityGaugeCalibratedImportMismatch')
  );
  const gaugeAdditionalDataImportMismatch = useSelector(
    createWorksheetSelector!('Preparation.NuclearDensityGaugePropertiesImportMismatch')
  );
  const isNuclearGaugeDensityCountImported = useSelector(createWorksheetSelector!('IsNuclearDensityCountImported'));
  const gaugeRecordImportMismatch = useSelector(
    createWorksheetSelector!('Preparation.NuclearDensityGaugeRecordImportedDataMismatch')
  );
  const gaugeId = useSelector(createWorksheetSelector!('Preparation.NuclearDensityGauge.Id')) as Guid;
  const gaugeSerialNumber = useSelector(createWorksheetSelector!('Preparation.NuclearDensityGaugeSerialNumber'));
  const gaugeMakeAndModel = useSelector(createWorksheetSelector!('Preparation.NuclearDensityGaugeMakeAndModel'));
  const gaugeModelNumber = useSelector(createWorksheetSelector!('Preparation.NuclearDensityGaugeModelNumber'));
  const testNumber = useSelector(createWorksheetSelector!('Preparation.TestNumber'));

  return (
    <PageSection heading="Preparation">
      <FieldSet>
        <Field input={<TextOutput />} name="Preparation.TestNumber" visible={hasValue(testNumber)} />
      </FieldSet>
      <ListFieldSection>
        <Field input={<QestlabListDropdown />} label="Weather" name="Preparation.Weather" listType={ListType.Weather} />
        <FieldSet>
          <Field
            input={<WorksheetEquipmentDropdown />}
            equipmentType="nuclear-density-gauge"
            name="Preparation.NuclearDensityGauge"
            importedCalibration={{
              Mismatch: gaugeCalibrationImportMismatch,
              ModelNumber: gaugeModelNumber,
            }}
            importedAdditionalData={{
              Mismatch: gaugeAdditionalDataImportMismatch || gaugeRecordImportMismatch,
              SerialNumber: gaugeSerialNumber,
              MakeAndModel: gaugeMakeAndModel,
            }}
            importModel={{ Id: gaugeId }}
          />
          <Field input={<TextOutput />} label="Serial Number" name="Preparation.NuclearDensityGaugeSerialNumber" />
          <Field input={<TextOutput />} label="Make/Model" name="Preparation.NuclearDensityGaugeMakeAndModel" />
        </FieldSet>
      </ListFieldSection>
      <ListFieldSection heading="Standard Counts">
        <Field
          input={isNuclearGaugeDensityCountImported ? <TextOutput /> : <NumericInput />}
          name="Preparation.DensityStandardCount"
        />
        <Field
          input={isNuclearGaugeDensityCountImported ? <TextOutput /> : <NumericInput />}
          name="Preparation.MoistureStandardCount"
        />
      </ListFieldSection>
    </PageSection>
  );
};

const ArizPreparationSection = withInjectedProps(Section);

export { ArizPreparationSection };
export default ArizPreparationSection;
